export default __webpack_public_path__ + "static/media/O-159.c56d7e83.png";